import { ReactElement } from 'react'
import { Stack, Typography } from '@mui/material'
import { organisationLabel } from '@utils'
import useActiveOrganisation from '../Navbar/hooks/useActiveOrganisation'

interface Props {
  name?: string
  /** Hidden on screens narrower than this (px), where the navbar has no room for it. */
  hideBelowWidth: number
}

/**
 * The project name in the navbar. Users who belong to several organisations also see the
 * organisation they are working in below it, in a smaller font.
 */
const NavbarProjectName = ({ name, hideBelowWidth }: Props): ReactElement => {
  const { organisations, activeOrganisation } = useActiveOrganisation({ notifyOnError: false })
  const showOrganisation = !!activeOrganisation && (organisations?.length ?? 0) > 1

  return (
    <Stack
      alignItems="center"
      sx={{ [`@media (max-width:${hideBelowWidth - 0.05}px)`]: { display: 'none' } }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary' }}>
        {name}
      </Typography>
      {showOrganisation && (
        <Typography
          sx={{ fontSize: 10, lineHeight: 1.2, color: 'text.secondary' }}
          data-cy="navbar-active-organisation"
        >
          {organisationLabel(activeOrganisation)}
        </Typography>
      )}
    </Stack>
  )
}

export default NavbarProjectName
